import { defineStore } from 'pinia'
import {
  defaultUserPreferences,
  type UserPreferencesPayload,
} from '~/composables/ui/useUserPreferences'

interface UserPrefsStoreState {
  prefs: UserPreferencesPayload
  isReady: boolean
  isLoading: boolean
}

export const useUserPrefsStore = defineStore('userPrefs', {
  state: (): UserPrefsStoreState => ({
    prefs: defaultUserPreferences(),
    isReady: false,
    isLoading: false,
  }),

  actions: {
    setPrefs(nextPrefs: UserPreferencesPayload): void {
      this.prefs = nextPrefs
    },

    setReady(ready: boolean): void {
      this.isReady = ready
    },

    setLoading(loading: boolean): void {
      this.isLoading = loading
    },
  },
})
